import React from 'react';
import EventListItem from './EventListItem';
import { resolveEventLocation } from '../lib/location';

/**
 * Business Events — the home-feed event cards (EventListItem) scoped to a
 * single business. Used on business detail pages in place of the old
 * server-rendered `.event-item` list.
 *
 * Only upcoming events are shown, oldest first. The whole section (heading
 * included) renders nothing when there are no upcoming events, replacing the
 * old "hide past events / hide empty section" inline scripts.
 *
 * The business author header is intentionally hidden: the visitor is already
 * on the hosting business's page, so the avatar/name row would be redundant.
 */
export default function BusinessEvents({
    events = [],
    businesses = [],
    locations = [],
    analytics,
    heading = 'Upcoming Events',
    sectionClass = '',
    headingClass = '',
}) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const upcoming = (events || [])
        .filter((event) => {
            const date = new Date(event.eventDate);
            if (isNaN(date.getTime())) return false;
            date.setHours(0, 0, 0, 0);
            return date >= today;
        })
        .sort((a, b) => new Date(a.eventDate) - new Date(b.eventDate));

    if (upcoming.length === 0) return null;

    return (
        <div className={sectionClass}>
            {heading && <h2 className={headingClass}>{heading}</h2>}
            <div className="space-y-6">
                {upcoming.map((event) => {
                    const business = businesses.find((b) => b.id === event.businessId);
                    const location = resolveEventLocation(event, business, locations);
                    return (
                        <EventListItem
                            key={event.id}
                            event={event}
                            business={business}
                            location={location}
                            analytics={analytics}
                            showAuthor={false}
                        />
                    );
                })}
            </div>
        </div>
    );
}
